import { render, staticRenderFns } from "./uiTitle.vue?vue&type=template&id=4ea684dc&scoped=true"
import script from "./uiTitle.vue?vue&type=script&lang=js"
export * from "./uiTitle.vue?vue&type=script&lang=js"
import style0 from "./uiTitle.vue?vue&type=style&index=0&id=4ea684dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea684dc",
  null
  
)

export default component.exports